<template>
    <div class="sidebar" v-bind:class="{active: collapseClass}">
        <a class="logo__wrapper" href="#/dashboard/customers">
            <img src="../../assets/logo.png" class="logo" id="logo">
        </a>
        <div class="role-type" v-if="isAdmin">ADMIN</div>

        <router-link v-if="isUser" :to="{path:Routes.CUSTOMERS}" class="route-button active">
            <i class="pg pg-user"></i>
            <span>
                Customers
            </span>
        </router-link>
        <router-link v-if="isUser" :to="{path:Routes.INVOICES}" class="route-button">
            <i class="pg pg-invoice"></i>
            <span>
                Invoices
            </span>
        </router-link>
        <router-link v-if="isUser" :to="{path:Routes.IMPORT}" class="route-button">
            <i class="pg pg-import"></i>
            <span>
                Import
            </span>
        </router-link>
        <router-link v-if="isAdmin" :to="{path:Routes.CLIENTS}" class="route-button">
            <i class="pg pg-users-checked"></i>
            <span>
                Clients
            </span>
        </router-link>
        <router-link v-if="isAdmin" :to="{path:Routes.USERS}" class="route-button">
            <i class="pg pg-users-checked"></i>
            <span>
                Users
            </span>
        </router-link>
        <a style="cursor: pointer;" class="route-button" v-if="user.mps_url"
           :href="user.mps_url" target="_blank">
            <i style="color: #4a4a4a;" class="pg pg-logout"></i>
            <span>Subscriptions</span>
        </a>
        <div style="cursor: pointer;" class="route-button" @click="logOut">
            <i class="pg pg-logout"></i>
            <span>
                Log Out
            </span>
        </div>


        <div class="route-button route-button--collapse" @click="collapse">
            <i class="pg pg-collapse" v-if="this.collapseClass"></i>
            <i class="pg pg-expand" v-else>
            </i>
            <span>
                Collapse
            </span>
        </div>
    </div>
</template>

<script>
  import Routes from '../../routes/ClientRoutes.js'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'Sidebar',
    computed: mapGetters(['isAdmin', 'isUser']),
    methods: {
      ...mapActions(['logout']),
      logOut () {
        this.logout()
      },
      collapse () {
        this.collapseClass = !this.collapseClass
      },
      redirectToMps: function ( ) {
        window.location = this.user.mps_url;
      }
    },
    data () {
      return {
        collapseClass: true,
        Routes,
        user: this.$store.getters.getAuth.user
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
